import {
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

import type { ApproveApplicationResponse } from "../types";

import { PENDING_APPLICATIONS_QUERY_KEY } from "./useGetPendingApplications";

export function useApproveApplication(): UseMutationResult<
  ApproveApplicationResponse,
  Error,
  { id: number }
> {
  const queryClient = useQueryClient();

  return useMutation<ApproveApplicationResponse, Error, { id: number }>({
    mutationFn: async ({ id }) =>
      await apiClient
        .url(`/kickstarter/admin/applications/${id}/approve`)
        .post()
        .json(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PENDING_APPLICATIONS_QUERY_KEY,
      });
    },
  });
}
